export const DEFAULT_MAILBOX = 'drive@instacar.gr';
